import { AccordionItem, AccordionPanel, AccordionPanelProps, AccordionProps, Box, BoxProps } from '@chakra-ui/react';
import { Accordion, AccordionButton, AccordionButtonProps } from 'components/UI';
import { specialFont } from 'constants/theme';
import { IParameterList } from '../../../../server/types';

type ParameterGroupProps = {
  title: string;
  paramKeys: IParameterList[];
  children: React.ReactNode;
  buttonProps?: AccordionButtonProps;
  panelProps?: AccordionPanelProps;
  accordionProps?: AccordionProps;
  boxProps?: BoxProps;
};

const ParameterGroup = ({
  paramKeys,
  title,
  children,
  buttonProps,
  panelProps,
  accordionProps,
  boxProps,
  ...props
}: ParameterGroupProps) =>
  paramKeys.length > 1 ? (
    <Accordion allowMultiple defaultIndex={[...Array(paramKeys.length).keys()]} {...accordionProps}>
      <AccordionItem {...props} borderTopWidth={0}>
        <AccordionButton fontFamily={specialFont} letterSpacing={3} pt={1} pb={3} {...buttonProps}>
          {title}
        </AccordionButton>
        <AccordionPanel p={0} {...panelProps}>
          {children}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  ) : (
    <Box {...boxProps}>{children}</Box>
  );

export default ParameterGroup;
